import { type FC } from 'react';
import CircularProgress, { type CircularProgressProps } from '@material-ui/core/CircularProgress';
import cx from 'classnames';

import styles from './styles.module.css';

interface Props {
  className?: string;
  size?: CircularProgressProps['size'];
  thickness?: CircularProgressProps['thickness'];
}

export const Loader: FC<Props> = ({ className, size, thickness, ...props }) => (
  <div
    className={cx(styles.root, className)}
    {...props}
  >
    <CircularProgress
      size={size}
      thickness={thickness}
    />
  </div>
);

Loader.displayName = 'Loader';
